/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftIdAppointmentsAcceptMutationResponse, PostApiBarberShiftIdAppointmentsAcceptPathParams, PostApiBarberShiftIdAppointmentsAccept400, PostApiBarberShiftIdAppointmentsAccept401, PostApiBarberShiftIdAppointmentsAccept403, PostApiBarberShiftIdAppointmentsAccept404, PostApiBarberShiftIdAppointmentsAccept500 } from "../entities/PostApiBarberShiftIdAppointmentsAccept";

function getPostApiBarberShiftIdAppointmentsAcceptUrl(id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]) {
  const res = { method: 'POST', url: `/api/barber/shift/${id}/appointments/accept` as const }
  return res
}

/**
 * @description Мастер вызывает клиента
 * @summary Вызвать клиента
 * {@link /api/barber/shift/:id/appointments/accept}
 */
export async function postApiBarberShiftIdAppointmentsAccept(id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, unknown>({ method : "POST", url : getPostApiBarberShiftIdAppointmentsAcceptUrl(id).url.toString(), ... requestConfig })
  return res.data
}